import { styled } from '@styledComponents';
import { Flex } from '@components/Flex';
import { TextPairing } from '@components/TextPairing';
import { themeSpace, themeMediaQuery } from '@utils/styledTheme.util';
import { CloudImage } from '@components/CloudImage';
import { Box } from '@components/Box';

export const StyledTextPairing = styled(TextPairing)`
  .text-pairing-body {
    max-width: 365px;
    padding-top: ${themeSpace(5)};
    ${themeMediaQuery('below_sm')} {
      padding: 0 ${themeSpace(6)};
    }
    ${themeMediaQuery('xl')} {
      max-width: 430px;
    }
  }
`;

export const StyledWrapper = styled(Flex)<{ bgTopLeft: string; bgBottomRight: string }>`
  position: relative;

  :before,
  :after {
    background-repeat: no-repeat;
    position: absolute;
    content: '.';
    color: transparent;
    max-width: 300px;
    max-height: 170px;
    width: 100%;
    height: 100%;

    ${themeMediaQuery('below_sm')} {
      content: none;
    }
  }

  :before {
    background-image: ${props => `url(${props.bgTopLeft})`};
    top: 0;
    left: 0;
  }

  :after {
    background-image: ${props => `url(${props.bgBottomRight})`};
    bottom: 0;
    right: 0;
  }
`;

export const StateIconTextContainer = styled(Flex)`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: ${themeSpace(6)};
`;

export const IconTextPairing = styled(TextPairing)`
  margin-top: ${themeSpace(6)};

  .text-pairing-title {
    ${themeMediaQuery('below_sm')} {
      font-size: 14px;
    }
  }
`;

export const LogosWrapper = styled(Flex)`
  height: 200px;
  position: relative;
  ${themeMediaQuery('below_sm')} {
    height: 150px;
  }
`;

export const LogosAnimation = styled(Flex)`
  position: absolute;
  height: 100%;
  will-change: transform;
`;

export const LogoBox = styled(Box)`
  display: flex;
  width: fit-content;
  justify-content: center;
`;

export const StyledLogoWrapper = styled(Flex)`
  min-width: 400vw;
  ${themeMediaQuery('sm')} {
    min-width: 280vw;
  }
`;

export const StyledLogo = styled(CloudImage)<{ width: number }>`
  width: ${({ width }) => width}%;
`;
